export const removeNulls = (items: Array<any>) => items.filter(item => item !== null);